import React, { useEffect, useState } from "react";
import "./styles.css";
/**
 * @function UICheckbox 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @example
 * <WidgetContainer>
 *  <UICheckbox />
 * </WidgetContainer>
 */
export default function UICheckbox(props) {
  const [ state, setState ] = useState(props.value ?? false);
  
  const ref = React.createRef();
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  const onChange = evt => {
    setState(ref.current.checked);

    if(props.onChange instanceof Function) {
      props.onChange(ref.current.checked);
    }
  };

  useEffect(() => setState(props.value ?? false), [ props.value ]);

  return (
    <div className="ui-checkbox set-width">
      <div className="ui-checkbox-container flex-container flex-horizontal align-center">
        <div className="checkbox-container set-width">
          <label className="custom-checkbox-item flex-container align-center">
              <input type="checkbox" className="custom-checkbox-input" checked={ state } ref={ ref } onChange={ onChange } { ...dataPoint } />
              <div className="custom-checkbox"></div>
              <div className="custom-check"></div>
          </label>
        </div>
      </div>
    </div>
  );
}
